export default __webpack_public_path__ + "static/og-0482fb797e798673f54567d2575872d2.png";